import React, { useRef, useEffect } from 'react'
import S3 from 'react-aws-s3'
import IconButton from '@mui/material/IconButton'
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined'

import useFileuploadStyles from './styles'
window.Buffer = window.Buffer || require('buffer').Buffer

const Fileupload = ({ formik }) => {
  const classes = useFileuploadStyles()
  const [selectedFile, setSelectedfile] = React.useState([])

  const inputRef = useRef(null)

  const config = {
    bucketName: 'distributedsystemfiles',
    // dirName: 'media', /* optional */
    region: 'ap-south-1',
    accessKeyId: 'AKIATJGPOMU42NBJR6OV',
    secretAccessKey: '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',
    // bucketName: process.env.AWS_S3_BUCKETNAME,
    // region: process.env.AWS_S3_REGION,
    // accessKeyId: process.env.AWS_S3_ACCESSKEYID,
    // secretAccessKey: process.env.AWS_S3_SECRETACCESSKEY,
  }

  const handleClick = () => {
    // 👇️ open file input box on click of another element
    inputRef.current.click()
  }

  const handlefileupload = (event) => {
    event.preventDefault()
    let newArr = inputRef.current.files
    for (let i = 0; i < newArr.length; i++) {
      handleFileChange(newArr[i])
    }
  }

  const handleFileChange = (files) => {
    const reader = new FileReader()
    reader.onload = function (e) {
      // const file = new Blob([new Uint8Array(e.target.result)], {
      //   type: files.type,

      // });
      // console.log(file, "e.target.result")
      const ReactS3Client = new S3(config)
      let newFileName = files.name.replace(/\..+$/, '')
      ReactS3Client.uploadFile(files, newFileName)
        .then((data) => {
          setSelectedfile((selectedFile) => [...selectedFile, data.location])
          console.log(data, 'result')
        })
        .catch((err) => console.error(err, 'upload error'))
    }
    reader.readAsArrayBuffer(files)
    return true
  }

  useEffect(() => {
    formik.setFieldValue(`plantDetails.plantDocsId`, selectedFile)
  }, [selectedFile])

  console.log(selectedFile, 'selectedFile')

  return (
    <div className={classes.root}>
      <div className="align_btw" style={{ height: '56px' }}>
        <div>
          <input
            style={{ display: 'none' }}
            ref={inputRef}
            type="file"
            multiple
            onChange={handlefileupload}
          />
          Plant Docs Upload
        </div>

        <IconButton edge="end" className="upload_i_clr" onClick={handleClick}>
          <CloudUploadOutlinedIcon />
        </IconButton>
      </div>
    </div>
  )
}

Fileupload.propTypes = {}

export default Fileupload
